import {
  SIZE,
  RADIUS,
  CENTER,
  STROKE_WIDTH,
  CIRCUMFERENCE,
} from './DivisionsSectionItemTimer.utils';
import { SLIDE_INTERVAL } from './DivisionsSectionCarousel.utils';
import { css } from '@onbeam/business-styled-system/css';
import { motion } from 'motion/react';

export const DivisionsSectionItemTimer = () => (
  <motion.svg
    className={css({
      pos: 'absolute',
      bottom: '3',
      right: '3',
    })}
    width={SIZE}
    height={SIZE}
    viewBox={`0 0 ${SIZE} ${SIZE}`}
    initial={{ scale: 0 }}
    animate={{ scale: 1 }}
    style={{ rotate: -90, scaleX: -1 }}
  >
    <motion.circle
      r={RADIUS}
      cx={CENTER}
      cy={CENTER}
      strokeWidth={STROKE_WIDTH}
      className={css({
        fill: '[transparent]',
        stroke: 'mono.90/40',
      })}
      initial={{ strokeDasharray: `${CIRCUMFERENCE} ${CIRCUMFERENCE}` }}
      animate={{ strokeDasharray: `0 ${CIRCUMFERENCE}` }}
      transition={{ duration: SLIDE_INTERVAL / 1000 - 0.1, ease: 'linear' }}
    />
  </motion.svg>
);
